module.exports = __webpack_public_path__ + "static/media/4.9368f431.jpg";